import { render, staticRenderFns } from "./KostenUndUmsaetze.vue?vue&type=template&id=3c226993&"
import script from "./KostenUndUmsaetze.vue?vue&type=script&lang=ts&"
export * from "./KostenUndUmsaetze.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports